import Flex from '~/common/components/Flex';
import Text from '~/common/components/Texts/Text';
import lang from '~/pages/IncomeCalculator/language.json';

export default function CalculationHistoryError() {
  return (
    <Flex height="100%" flexDirection="column">
      <Text fontSize="lg" textAlign="center" flexBasis="calc(100% - 36px)">
        {lang.ERROR_CALC_HISTORY_RESULT}
      </Text>
    </Flex>
  );
}
